<template>
  <v-dialog
      v-model="dialogReg"
      max-width="510"
  >
    <div class="modal">
      <img class="d-block mt-5 mb-7 mx-auto" src="../assets/img/logo_elegance.png"
           srcset="../assets/img/logo_elegance2x.png 2x" alt="" width="205" height="86">
      <h5 class="text-h5 text-center mb-2">Регистрация</h5>
      <p class="text-subtitle-2 text-center">Очень простая регистрация</p>
      <v-form class="mt-6" v-model="valid" ref="form">
        <v-text-field
            type="text"
            class="custom-input mb-5"
            v-model.trim="regName"
            hide-details="auto"
            label="Имя"
            filled
            required
            :rules="regNameRules"
            validate-on-blur
        ></v-text-field>
        <v-text-field
            type="tel"
            class="custom-input mb-5"
            v-model.trim="regPhone"
            hide-details="auto"
            label="Номер телефона"
            filled
            required
            validate-on-blur
            :error-messages="getUserMessages.statusPhone ? getUserMessages.text : null"
            @input="clearUserMessage"
            v-mask="'+7-(###)-###-##-##'"
            :rules="phoneRules"
        ></v-text-field>
        <v-text-field
            type="email"
            class="custom-input mb-5"
            v-model.trim="regEmail"
            hide-details="auto"
            label="Введите свой email"
            filled
            required
            :rules="emailRules"
            validate-on-blur
            :error-messages="getUserMessages.statusEmail ? getUserMessages.text : null"
            @input="clearUserMessage"
        ></v-text-field>
        <v-text-field
            class="custom-input mb-5"
            v-model="regPassword1"
            hide-details="auto"
            filled
            :append-icon="showRegPassword1 ? 'mdi-eye-off' : 'mdi-eye'"
            label="Введите пароль"
            :type="showRegPassword1 ? 'text' : 'password'"
            @click:append="showRegPassword1 = !showRegPassword1"
            required
            :rules="regPasswordRules"
        ></v-text-field>
        <v-text-field
            class="custom-input mb-5"
            v-model="regPassword2"
            hide-details="auto"
            filled
            :append-icon="showRegPassword2 ? 'mdi-eye-off' : 'mdi-eye'"
            label="Введите пароль еще раз"
            :type="showRegPassword2 ? 'text' : 'password'"
            @click:append="showRegPassword2 = !showRegPassword2"
            required
            :rules="regPassword2Rules"
        ></v-text-field>
        <v-btn
            class="btn-primary-md mb-5"
            :disabled="!valid"
            x-large
            color="primary"
            rounded
            block
            @click="register"
        >
          Зарегистрироваться
        </v-btn>
        <div class="d-flex align-center justify-space-between">
          <a class="text-body-2 black--text ml-auto" href="#" @click.prevent="openLoginDialog">Уже зарегистрирован</a>
        </div>
      </v-form>
      <v-btn
          @click="dialogReg = false"
          class="modal__close custom-icon-btn primary"
          icon
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill="#ffffff"
                d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z"/>
        </svg>
      </v-btn>
    </div>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  data() {
    return {
      regName: '',
      regPhone: '',
      regEmail: '',
      regPassword1: '',
      regPassword2: '',
      showRegPassword1: false,
      showRegPassword2: false,
      valid: true,
      emailRules: [
        v => !!v || 'Это обязательное поле',
        v => /^[-\w.]+@([A-z0-9][-A-z0-9]+\.)+[A-z]{2,10}$/.test(v) || 'Введите валидный email'
      ],
      regNameRules: [
        v => !!v || 'Это обязательное поле',
        v => /^[а-яА-Яa-zA-Z0-9]{1,15}$/.test(v) || 'Латинские и русские буквы и цифры от 2 до 15 символов'
      ],
      regPasswordRules: [
        v => !!v || 'Это обязательное поле',
        v => /(?=^.{6,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/.test(v) || 'Строчные и прописные латинские буквы, цифры. Минимум 6 символов'
      ],
      regPassword2Rules: [
        v => !!v || 'Это обязательное поле',
        v => (!!v && v) === this.regPassword1 || 'Пароли не совпадают'
      ],
      phoneRules: [
        v => !!v || 'Это обязательное поле',
        v => /\+7-\([0-9]{3}\)-[0-9]{3}-[0-9]{2}-[0-9]{2}/.test(v) || 'Номер телефона введен не полностью'
      ]
    }
  },
  methods: {
    ...mapActions(['registerAction', 'dialogAuthAction']),
    ...mapMutations(['setUserMessage']),
    register() {
      if (this.$refs.form.validate()) {
        this.registerAction({
          name: this.regName,
          phone: this.regPhone,
          email: this.regEmail,
          password: this.regPassword1,
        })
      }
    },
    openLoginDialog() {
      this.dialogReg = false
      this.dialogAuthAction({
        dialog: 'dialogLogin',
        status: true
      })
    },
    clearUserMessage() {
      this.setUserMessage({
        statusPhone: false,
        statusEmail: false,
        text: ''
      })
    }
  },
  computed: {
    ...mapGetters(['getAuthDialogs', 'getUserMessages']),
    dialogReg: {
      get() {
        return  this.getAuthDialogs.dialogReg
      },
      set(value) {
        this.dialogAuthAction({
          dialog: 'dialogReg',
          status: value
        })
      }
    }
  }
}
</script>

<style scoped>

</style>